import {
  LocationModel,
  LocationFilterModel,
  LocationListModel,
  LocationCreateModel,
  LocationCreateModelFile,
} from '@kanzi-apes/kanzi-models';
import { Action } from '@ngrx/store';

export enum LocationActionTypes {
  LoadList = '[location] Load list',
  LoadListComplete = '[location] Load List Complete',
  LoadListError = '[location] Load List Error',
  LoadLocation = '[location] Load location',
  LoadLocationComplete = '[location] Load location Complete',
  LoadLocationError = '[location] Load location Error',
  LoadMasterFile = '[location] Load location master',
  LoadMasterFileComplete = '[location] Load location master complete',
  LoadMasterFileError = '[location] Load location master error',
  Create = '[location] Create',
  CreateComplete = '[location] Create Complete',
  CreateError = '[location] Create Error',
  Delete = '[location] Delete',
  DeleteComplete = '[location] Delete Complete',
  DeleteError = '[location] Delete Error',
  Edit = '[location] Edit',
  EditComplete = '[location] Edit Complete',
  EditError = '[location] Edit Error',
}

export class LoadList implements Action {
  readonly type = LocationActionTypes.LoadList;
  constructor(public payload: LocationFilterModel) {}
}

export class LoadListComplete implements Action {
  readonly type = LocationActionTypes.LoadListComplete;
  constructor(public payload: LocationListModel) {}
}

export class LoadListError implements Action {
  readonly type = LocationActionTypes.LoadListError;
  constructor(public payload: string) {}
}
export class LoadLocation implements Action {
  readonly type = LocationActionTypes.LoadLocation;
  constructor(public payload: number) {}
}

export class LoadLocationComplete implements Action {
  readonly type = LocationActionTypes.LoadLocationComplete;
  constructor(public payload: LocationModel) {}
}

export class LoadLocationtError implements Action {
  readonly type = LocationActionTypes.LoadLocationError;
  constructor(public payload: string) {}
}

export class Create implements Action {
  readonly type = LocationActionTypes.Create;
  constructor(public payload: LocationCreateModel) {}
}

export class CreateComplete implements Action {
  readonly type = LocationActionTypes.CreateComplete;
  constructor(public payload: LocationModel) {}
}

export class CreateError implements Action {
  readonly type = LocationActionTypes.CreateError;
  constructor(public payload: string) {}
}

export class Delete implements Action {
  readonly type = LocationActionTypes.Delete;
  constructor(public payload: LocationModel) {}
}

export class DeleteComplete implements Action {
  readonly type = LocationActionTypes.DeleteComplete;
}

export class DeleteError implements Action {
  readonly type = LocationActionTypes.DeleteError;
  constructor(public payload: string) {}
}
export class Edit implements Action {
  readonly type = LocationActionTypes.Edit;
  constructor(public payload: LocationCreateModel) {}
}

export class EditComplete implements Action {
  readonly type = LocationActionTypes.EditComplete;
  constructor(public payload: LocationModel) {}
}

export class EditError implements Action {
  readonly type = LocationActionTypes.EditError;
  constructor(public payload: string) {}
}

export class LoadMasterFile implements Action {
  readonly type = LocationActionTypes.LoadMasterFile;
  constructor(public payload: LocationCreateModelFile) {}
}

export class LoadMasterFileComplete implements Action {
  readonly type = LocationActionTypes.LoadMasterFileComplete;
  constructor(public payload: any) {}
}

export class LoadMasterFileError implements Action {
  readonly type = LocationActionTypes.LoadMasterFileError;
  constructor(public payload: any) {}
}

export type LocationActions =
  | LoadList
  | LoadListComplete
  | LoadListError
  | LoadLocation
  | LoadLocationComplete
  | LoadLocationtError
  | Create
  | CreateComplete
  | CreateError
  | Delete
  | DeleteComplete
  | DeleteError
  | Edit
  | EditComplete
  | EditError
  | LoadMasterFile
  | LoadMasterFileComplete
  | LoadMasterFileError;
